import { render } from "./Edit.vue?vue&type=template&id=a5b870c4&scoped=true"
import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=a5b870c4&scoped=true&lang=css"

import exportComponent from "/Users/herianto/Projects/yeu-logistik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5b870c4"],['__file',"resources/js/Pages/AssetGroups/Edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5b870c4"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5b870c4', __exports__)) {
    console.log('reload')
    api.reload('a5b870c4', __exports__)
  }
  
  module.hot.accept("./Edit.vue?vue&type=template&id=a5b870c4&scoped=true", () => {
    console.log('re-render')
    api.rerender('a5b870c4', render)
  })

}


export default __exports__